/**
 * Constants for React Query keys for parent-frontend.
 * All query keys should be defined here to ensure consistent caching behavior.
 */

export const QUERY_KEYS = {
  // User/Auth related keys
  PARENT_USER_PROFILE: 'parent-user-profile',

  // Student/Child related keys (assuming a parent can view child details)
  CHILD_DETAILS: 'child-details',
  CHILD_ATTENDANCE: 'child-attendance',
  CHILD_GRADES: 'child-grades',
  CHILD_FEES: 'child-fees',
  CHILD_EVENTS: 'child-events',
  CHILD_NOTICES: 'child-notices',

  // Dashboard specific keys
  PARENT_DASHBOARD: 'parent-dashboard',

  // Settings specific to parent portal
  PARENT_SETTINGS: 'parent-settings',
  PARENT_NOTIFICATION_PREFERENCES: 'parent-notification-preferences',

  // Add other parent-frontend specific keys as the application grows
  GUARDIAN_PROFILE: 'guardianProfile',
  GUARDIAN_CHILDREN: 'guardianChildren',
  STUDENT_DETAILS: 'studentDetails',
  ACADEMIC_CALENDAR_EVENTS: 'academicCalendarEvents',
  STUDENT_LEAVES: 'studentLeaves',
  STUDENT_SESSIONS: 'student-sessions',
  STUDENT_SUGGESTIONS: 'studentSuggestions',
  // Add key for student monthly calendar with attendance
  STUDENT_MONTHLY_CALENDAR: 'student-monthly-calendar',

  STUDENT_DISCIPLINARY_RECORDS: 'student-disciplinary-record',
  INSTITUTE_SETTINGS: 'institute-settings',
};

// Optional: Default query configurations (can be adapted from frontend if needed)
export const QUERY_CONFIG = {
  DEFAULT: {
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    retry: 1,
  },
  STATIC: {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
    cacheTime: 7 * 24 * 60 * 60 * 1000, // 7 days
    retry: 1,
  },
};

// Optional: Invalidation events (can be adapted if parent-frontend has specific events)
export const INVALIDATION_EVENTS = {
  CHILD_DATA_UPDATED: 'child-data-updated',
  FEE_PAYMENT_SUCCESS: 'fee-payment-success',
};
